import {
  CustomButton,
  CustomLabel,
  CustomWidth,
  FlexContainer,
  FooterOption,
  IconButton,
  Input,
  IStyleProps,
  LeftBanner,
  LockIcon,
} from "@mindmemobile/mm-shared-global";
import styled from "styled-components";
import { HeaderSection } from "./ItemHeader.styles";
import {
  CheckoutItemsWrapper,
  FreeItemWrapper,
  ItemDetailsCard,
  PurchaseColoredBackground,
  PurchaseWrapper,
} from "./PurchaseStyles";
import { CustomLine, LabelCell, MainOuterCard } from "./Layout.styles";
import { DropdownButton } from "react-bootstrap";
import { HTMLAttributes } from "react";

interface IStyledProps {
  active?: boolean;
  width?: string;
  textWidth?: string;
}

export const DropdownContainer2 = styled.div`
  position: relative;
  width: 400px;
  font-family: Arial, sans-serif;
`;

export const DropdownImage = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
`;

export const DropdownContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DropdownTitle = styled.span`
  font-weight: bold;
`;

export const DropdownList = styled.ul`
  position: absolute;
  width: 100%;
  max-height: 150px;
  overflow-y: auto;
  border: 1px solid #ccc;
  border-top: none;
  z-index: 1;
  background: #fff;
  list-style: none;
  margin: 0;
  padding: 0;
`;

// export const BulletLabel = styled(CustomLabel)`
//     position: relative;
//     padding-left: 15px;
//     font-size: 10px;
//     line-height: 15px;
//     color: #555;
//     &::before {
//         content: '•';
//         position: absolute;
//         left: 0;
//         color: black;
//         font-size: 20px;
//     }
// `;

export const DropdownContainer = styled.div`
  position: relative;
  width: 300px;
`;

export const DropdownHeader = styled.div`
  padding: 10px;
  border: 1px solid #ccc;
  display: flex;
  align-items: center;
  cursor: pointer;
  border-radius: 5px;
`;

export const DropdownListItem = styled.li`
  padding: 10px;
  cursor: pointer;
  &:hover {
    background: #f0f0f0;
  }
`;

export const Icon = styled.img`
  width: 24px;
  height: 24px;
  margin-left: 10px;
`;
// Place checkout common CSS here !!!
export const CheckoutCommonWrapper = styled.span`
  ${CustomLabel}.checkout-headers {
    font-size: 18px;
    font-weight: 600;
  }
  .option-checkout {
    .styled-chkbox input {
      height: 18px;
      width: 18px;
    }
    .branding-help-num {
      width: 125px;

      .header {
        width: 125px;
      }
      .select-header-span {
        padding-left: 0px;
      }
      .options-menu {
        border-radius: 4px;
        transform: translate(0px, 46px);
      }
    }
    .branding-country-dropdown > div {
      /* min-width: 210px; */
      /* max-width: 250px; */
      width: 250px;
      border-color: #aaa;
      height: 40px;
      .phone-data {
        font-size: 14px;
      }
      .custom-label {
        font-size: 16px;
      }
      button {
        min-width: 50px;
        padding-right: 10px;
      }
      input {
        width: 100%;
        font-size: 16px;
        &::placeholder {
          font-size: 16px;
        }
      }
      .dropdown-menu {
        max-height: 142px !important;
        overflow-y: auto;
        transform: translate(-6px, 40px) !important;
        z-index: 1001;
        &::-webkit-scrollbar {
          width: 0.7em;
          height: 0.4em;
          background-color: #15283717;
          border-radius: 10px;
        }
        &::-webkit-scrollbar-thumb {
          outline: 1px solid #ddd;
          background-color: rgba(21, 40, 55, 0.3);
          border-radius: 10px;
        }
      }
    }
  }
  .chckout-align-space {
    margin-left: 30px;
  }
  .btn-caption-dpdn {
    min-width: 120px;
    max-width: 300px;
    width: auto;
    .header {
      min-width: 120px;
      width: auto;
      max-width: 300px;
    }
    .options-menu {
      width: 220px;
    }
    .select-header-span {
      width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
  .custom-caption-input {
    width: 150px;
    input {
      width: 150px;
    }
  }
  .payment-method-select {
    width: 450px;
    margin-left: 2px;
    .payment-method__control {
      border-color: #aaa;
      box-shadow: none;
      &:focus,
      &:hover {
        outline: none;
        border-color: #aaa;
        box-shadow: none;
      }
    }
    .payment-method__menu-list {
      max-height: 130px !important;
      overflow-y: auto !important;
    }
  }
  .colored-block-div {
    &:not(:last-child) {
      width: 158px;
      /* &.colored-block-margin {
                margin-bottom: 20px;
            } */
    }
    /* > div {
            position: absolute;
        } */
  }
  .checkout-color-picker {
    position: absolute;
    top: 0;
    left: 0;
    transform: translate(0px, 30px);
    z-index: 1001 !important;
  }
  .item-select-dpdn {
    min-width: 200px;
    .header {
      min-width: 200px;
    }
    .select-header-span {
      min-width: 50px;
    }
  }
  .email-input {
    width: 250px;
  }
  @media (max-width: 1300px) {
    .btn-caption-dpdn {
      min-width: 120px;
      max-width: 300px;
      width: auto;
      .header {
        min-width: 120px;
        width: auto;
        max-width: 300px;
      }
      .options-menu {
        width: 220px;
      }
    }
  }
`;

export const CheckoutDetailMainWrapper = styled.div`
  padding: 30px;
  .single-checkout-card {
    height: 130px;
    width: 170px;
    margin: 0 auto 15px;
    img {
      height: 100%;
      width: 100%;
      border: 1px solid transparent;
      cursor: pointer;
      border-radius: 6px;
    }
  }
  .dpdn-with-icons {
    img {
      height: 20px;
      width: 20px;
    }
    .select-header-icon .fa {
      color: #555;
    }
    &.sold-by-dropdown {
      margin: 0px 0px 50px 0px;
      .header {
        min-height: 40px;
        height: auto;
        padding: 9px 8px;
      }
      .options-menu {
        transform: translate(0px, 50px);
      }
      .logo-in-dpdn {
        height: 35px;
        width: 35px;
        border-radius: 50%;
      }
      .select-header-icon {
        transform: translate(0px, 10px);
      }
      .select-header-span {
        padding: 0px;
      }
    }
    .options-menu {
      color: #555;
    }
    .dropdown-option-list {
      max-height: 85px;
    }
  }
  .layout-outer-wrapper {
    margin-top: 50px !important;
    margin-bottom: 50px !important;
  }
`;

export const CheckoutDetailSection = styled.div<IStyleProps>`
  width: ${(props) => props.width || "45%"};
  padding: 30px;
  .checkout-labels {
    margin-bottom: 25px;
    &:not(.item-checkout-label) {
      margin-top: 30px;
      &.labels-mt-35 {
        margin-top: 35px;
      }
    }
    > label {
      font-size: 24px;
      line-height: 30px;
    }
  }
  .checkout-item-name {
    display: flex;
    flex: 1;
    align-items: center;
    gap: 10px;
    position: relative;
    .input-wrapper {
      flex: 1 1 0;
    }
    input {
      border: none;
      font-size: 16px;
      font-weight: 600;
      color: #000;
      width: 100%;
      /* padding-left: 0px; */
      padding: 0px 0px 10px 0px;
      &:focus {
        outline: none;
      }
    }
    img {
      height: 14px;
      width: 14px;
      margin-bottom: 8px;
    }
  }
  .qty-input {
    margin: 10px 0px 20px;
    input {
      width: 60px;
      height: 30px;
      border: 1px solid #ccc;
      border-radius: 4px;
      padding: 0px 10px;
      font-size: 12px;
      font-weight: 600;
      color: #000;
      text-align: center;
      &:focus {
        outline: none;
      }
    }
    img {
      height: 15px;
      width: 15px;
    }
  }
  .yes-no-icon {
    height: 10px;
    width: 10px;
    margin-right: 3px;
    margin-bottom: 2px;
    &.tick-icon {
      height: 13px;
      width: 13px;
    }
  }
  .yes-no-section {
    > div {
      margin-right: 20px;
      margin-bottom: 8px;
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
    }
  }
  ${HeaderSection} {
    margin-bottom: 30px;
  }
  .checkout-checkboxes {
    input.form-check-input {
      height: 18px;
      width: 18px;
      margin-top: 4px;
    }
    label {
      font-size: 14px;
      font-weight: 400;
      line-height: 16px;
    }
    .single-select-wrapper {
      width: auto;
      min-width: 150px;
      .header {
        width: auto;
        min-width: 150px;
        font-size: 14px;
        font-weight: 400;
        height: 35px;
        line-height: 20px;
      }
      .select-header-icon {
        height: 30px;
      }
    }
  }
  .dpdn-no-border {
    .options-menu {
      width: auto;
      min-width: 100px;
    }
    .select-header-span {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
    }
    .header {
      padding-left: 0px;
    }
    .select-header-icon {
      transform: translate(2px, 0px);
      .fa {
        color: #555;
      }
      i {
        font-size: 21px;
      }
    }
  }
  .recommend-dropdown {
    ${CustomLabel} {
      font-size: 12px;
      margin-bottom: 4px;
      line-height: 14px;
    }
    .select-header-icon {
      border-left: none;
    }
    .options-menu {
      min-width: 300px;
      max-width: 600px;
      width: auto;
      transform: translate(0px, 40px);
    }
  }
  ${LockIcon} {
    width: 13px;
    height: 17px;
    background-size: 12px;
  }
  .marketing-radio-btns {
    margin-left: 32px;
    .form-check-label {
      color: #555;
    }
  }
  .divided-component.wrapped-columns {
    max-width: 500px;
  }
  .renew-desc {
    text-align: right;
    font-size: 14px;
    line-height: 18px;
    margin-top: 2px;
  }
  .dpdn-chckout-item {
    margin: 10px 0px;
    .header {
      border: none;
      min-width: 50px !important;
      width: auto !important;
      max-width: 100% !important;
      display: inline-block;
      padding-left: 0px;
      .select-header-span {
        width: auto;
        padding-left: 0px;
      }
      .sell-recurring-icon {
        height: 20px;
        width: 20px;
      }
    }
  }
  .chckout-payment {
    max-width: 635px;
    .datepicker-overlay-container {
      transform: translate(-1px, 15%);
    }
    .pay-datepicker {
      input:focus {
        box-shadow: none;
      }
    }
  }
  .marketing-radio-spacing {
    margin: 0px 0px 20px 32px;
  }
  .customised-sell-dpdn {
    .options-menu {
      width: 400px;
      padding: 10px 0px 0px;
      height: unset !important;
      max-height: unset !important;
      div:nth-child(2) {
        max-height: 80px;
        li {
          padding-left: 14px;
        }
      }
    }
    ${FooterOption} {
      width: 100%;
      padding: 8px 15px;
      background: rgba(248, 248, 248, 1);
      border-top: none;
      label {
        color: rgba(85, 107, 184, 1);
        font-size: 14px;
        font-weight: 400;
      }
    }
    .sell-dpdn-footer {
      flex: 1;
    }
    .searchable-dropdown-input {
      padding-left: 14px;
    }
  }
  .search-selected-dpdn-menu {
    width: 393px;
    border-top: none;
    border-radius: 0px 0px 4px 4px;
  }
  .single-select-wrapper {
      &.checkout-segment-dpdn,
      &.moneyback-chkout {
        width: 225px;
        .header {
          width: 225px;
        }
      }
    }
  @media (min-width: 1200px) and (max-width: 1800px) {
    /* .single-select-wrapper {
      &.checkout-segment-dpdn,
      &.moneyback-chkout {
        width: 225px;
        .header {
          width: 225px;
        }
      }
    } */
    .chkout-pay-select {
      width: 410px !important;
    }
  }
  @media (min-width: 1600px) and (max-width: 1900px) {
    width: 45%;
  }
  @media (min-width: 1901px) and (max-width: 2400px) {
    width: 35%; // managing the width of the checkout left panel
  }
  @media (min-width: 2401px) {
    width: 30%;
  }
`;
export const IconAfterText = styled.img<IStyledProps>`
  /* before using this component apply position relative to its parent */
  position: absolute;
  left: ${(props) => props.textWidth || "0"};
`;
export const MultiplePriceWrapper = styled.div<IStyleProps>`
  /* width: 100%; */
  /* ${MainOuterCard} {
      border: 1px solid #556bb8;
  } */
  &.payment-price-wrapper {
    background-color: ${(props) => props.bgColor || "#fff"};
    .divided-component.wrapped-columns {
      justify-content: center;
      > div {
        max-width: 500px;
        width: 48%;
      }
      .single-select-wrapper.dpdn-no-border .options-menu li {
        font-size: 12px;
      }
    }
    ${CustomButton}.promo-apply-btn {
      background-color: transparent;
      color: #556bb8;
      padding: 0px;
      min-width: 65px !important;
    }
  }
  .item-right-panel {
    max-width: 600px;
    margin: 0 auto;
    .recommended-outer-card {
      width: 600px;
      padding: 24px 24px 24px 55px;
      position: relative;
      width: 100% !important;
      min-height: 160px;
      &.no-recommendations {
        padding: 24px 15px !important;
      }
    }
  }
  /* .bundle-flex-resp {
    align-items: flex-start;
    .bundle-flex {
      align-items: center;
    }
  } */

  ${CustomButton} {
    min-width: 80px;
    width: auto;
    &.call-us-btn {
      border-radius: 25px;
    }
  }
  .left-outer-card {
    /* min-width: 60%; */
    max-width: 600px;
    margin: 0 auto;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .carousel-indicators {
    display: none;
  }
  .carousel-inner .carousel-item {
    text-align: center;
  }
  &.multiple-item-with-tab {
    ${MainOuterCard} {
      display: flex;
      flex-direction: column;
      gap: 30px;
      align-items: center;
      /* justify-content: center; */ // creating issue if the height of the card is not same, specaillay for custom options
      justify-content: flex-start;
      width: 370px;
      min-height: 460px;
      padding: 30px 25px 30px;
      border-radius: 15px;
      min-height: 575px;
      ${CustomLabel} {
        text-align: center;
        span,
        pre {
          white-space: normal;
        }
      }
      &.featured-banner {
        border-radius: 0px 0px 15px 15px;
      }
    }
    .multiple-free-items {
      ${CustomLine} {
        margin: 0px 0px 10px;
      }
    }
    .error-warning {
      margin: 15px 0px 0px !important;
    }
    .option-carousel-wrapper {
      margin-top: 10px;
      /* max-height: 200px; */ //creating issue for the smaller images of the carousel
      max-width: 180px; //earlier it was 250px, creating issue with arrows
    }
    .carousel-inner {
      /* left: 50%;
          transform: translate(-50%, 0px); */
      min-height: 100px;
      max-height: 200px;
      height: auto;
      .carousel-item {
        /* height: 200px;
              width: 200px; */
        /* img {
                  max-height: 100%;
                  height: auto;
                  max-width: 100%;
                  width: auto;
              } */
      }
    }
    ${CustomButton} {
      height: 40px;
      min-width: 120px;
      color: #fff;
    }
    .bundle-flex {
      /* flex-wrap: wrap; */
      /* justify-content: center; */
      /* align-items: center; */ // creating issue if the height of the card is not same
      gap: 50px;
      padding: 0px 20px;
      label {
        word-break: break-word;
      }
      /* New CSS */
      max-width: unset;
      /* flex-wrap: unset; */
      /* overflow-x: auto; */
      &::-webkit-scrollbar {
        width: 0.7em;
        height: 0.4em;
        background-color: #15283717;
        border-radius: 10px;
      }
      &::-webkit-scrollbar-thumb {
        outline: 1px solid #ddd;
        background-color: rgba(21, 40, 55, 0.3);
        border-radius: 10px;
      }
      .item-header {
        height: 50px;
      }
    }
    .item-header {
      font-size: 20px;
      font-weight: 600;
      line-height: 24px;
      color: #000;
    }
  }
  .recommend-price-desc {
    ${CustomLabel} {
      font-weight: 600;
    }
    .charcoal-label {
      color: #aaa;
      font-weight: 400;
    }
  }
  .dynamic-labels-card {
    ol {
      padding-left: 1rem;
    }
  }
  //make centered for the single item step
  /* .bundle-flex {
      max-width: 1250px;
  } */
  /* CSS for the purchase page without media i.e. left aligned  */
  .right-panel-wo-media {
    width: 100% !important;
    max-width: 100% !important;
    margin-left: 50px !important;
    .item-right-panel {
      margin: 0px !important;
    }
  }
  @media (min-width: 260px) and (max-width: 320px) {
    &.multiple-item-with-tab {
      ${MainOuterCard} {
        width: 250px;
      }
    }
  }
  @media (min-width: 321px) and (max-width: 468px) {
    &.multiple-item-with-tab {
      ${MainOuterCard} {
        width: 270px;
      }
    }
  }
  @media (min-width: 260px) and (max-width: 1200px) {
    .bundle-flex {
      gap: 20px !important;
      justify-content: center;
      padding-bottom: 30px !important;
    }
    &.multiple-item-with-tab {
      ${MainOuterCard} {
        min-height: 200px;
        &.featured-banner {
          margin-top: 42px;
        }
      }
    }
    &.payment-price-wrapper {
      .divided-component.wrapped-columns {
        > div {
          max-width: 450px;
          width: 100%;
        }
      }
    }
    .recommended-outer-card {
      padding: 55px 15px 24px 15px !important;
      /* width: 80% !important; */
    }
    &.multiple-item-with-tab {
      ${MainOuterCard} {
        min-height: 200px;
      }
    }
    .right-panel-wo-media {
      margin-left: 0px !important;
    }
  }
  @media (min-width: 1024px) and (max-width: 1200px) {
    &.multiple-item-with-tab {
      ${MainOuterCard} {
        min-height: 200px;
        &.featured-banner {
          margin-top: 0px;
        }
      }
    }
  }
  @media (min-width: 1024px) and (max-width: 1300px) {
    ${FreeItemWrapper} {
      max-width: 300px;
      width: 300px;
    }
  }
  @media (min-width: 2000px) {
    /* .bundle-flex-resp { */
    /* align-items: center; */
    /* .bundle-flex {
        align-items: center;
        justify-content: center;
        &.center {
          justify-content: center;
        }
      } */
    /* } */
  }
`;
export const CheckoutPreviewSection = styled.div<IStyledProps>`
  // width: ${(props) => props.width || "750px"};
  // padding: 20px 40px;
  background: #f8f8f8;
  border-radius: 0px 0px 0px 10px;
  height: 100%;
  min-height: 400px;
  overflow-y: auto;

  /* for mobile view  */
  ${MultiplePriceWrapper} {
    .bundle-flex {
      gap: 20px !important;
    }
    &.multiple-item-with-tab {
      ${MainOuterCard} {
        min-height: 200px;
        &.featured-banner {
          margin-top: 42px;
        }
      }
    }
    &.payment-price-wrapper {
      .divided-component.wrapped-columns {
        > div {
          max-width: 500px;
          width: 100% !important;
        }
      }
    }
  }
  ${PurchaseColoredBackground} {
    border-radius: 0px;
    padding: 30px 25px;
    .wrapped-columns {
      flex-wrap: wrap;
      justify-content: center;
      gap: 20px !important;
      > div {
        width: 100%;
      }
    }
    .recommended-outer-card {
      width: auto !important;
      max-width: 600px;
    }
    .item-header {
      font-size: 24px;
      line-height: 30px;
      text-align: center;
      & + label {
        text-align: center;
      }
    }
    .left-outer-card {
      /* width: 80% !important; */
      max-width: 600px !important;
      justify-content: center;
      align-items: center;
      .item-header {
        & + label {
          text-align: center;
          max-width: 37ch;
        }
      }
    }
    .item-right-panel {
      padding: 0px;
      align-items: center;
      .recommended-outer-card {
        width: 100% !important;
        max-width: 600px;
        padding: 55px 15px 24px 15px !important;
        min-height: 160px;
        &.no-recommendations {
          padding: 24px 15px !important;
        }
        .item-header {
          font-size: 22px;
          line-height: 26px;
          text-align: left;
          & + label {
            text-align: left;
            font-size: 12px;
            line-height: 16px;
            width: 100%;
          }
        }
      }
    }
    .multiple-item-with-tab {
      ${MainOuterCard} {
        width: inherit;
        max-width: 280px;
        min-height: 200px;
        padding: 20px 25px !important;
      }
    }
    .desc-width {
      width: inherit;
    }
    ${CustomButton} {
      min-width: 80px;
    }
    .purchase-section {
      padding: 25px 0px 25px 15px !important;
    }
  }
  ${PurchaseWrapper} {
    padding: 20px 25px;
    // height: auto;
    .purchase-profile {
      img {
        height: 30px;
        width: 30px;
      }
      ${FlexContainer} {
        gap: 5px;
      }
    }
    .purchase-steps {
      display: none;
    }
    .purchase-steps-subtopbar {
      display: block;
      /* margin-bottom: 10px; */
      > ${FlexContainer} {
        justify-content: center;
        margin-top: 10px;
        .fa-chevron-right {
          margin-right: 10px;
        }
      }
      &.topbar-with-margin {
        margin-top: 10px;
      }
    }
    ${PurchaseColoredBackground} {
      padding: 30px 20px;
    }
    .purchase-section {
      padding: 50px 15px;
    }
    .purchase-options-screen {
      .wrapped-columns {
        width: 400px;
        margin: 0 auto;
      }
      .option-carousel-wrapper {
        width: 100%;
        .carousel.slide {
          width: 100%;
        }
      }
      .options-right-panel {
        padding: 0px;
        label {
          text-align: left;
        }
      }
    }
    .item-header + label {
      text-align: left;
    }
    .addon-body-scroll {
      overflow-x: hidden;
      ${ItemDetailsCard} {
        width: 400px;
      }
      > ${FlexContainer} {
        padding: 10px 20px 0px !important;
      }
    }
    ${CheckoutItemsWrapper} {
      ${MainOuterCard} {
        padding: 30px 15px;
      }
    }

    .wrapped-columns {
      &.wrapped-max-width {
        max-width: 500px;
        margin: 0 auto;
      }
    }

    .purchase-nav-flex {
      padding: 0px;
    }
  }
  ${ItemDetailsCard} {
    > ${FlexContainer} {
      flex-direction: column-reverse;
      flex-wrap: wrap;
      align-items: center;
      ${CustomWidth} {
        &:first-child {
          width: 100%;
        }
        &:last-child {
          width: 100%;
        }
      }
      .add-on-image {
        margin: 0 auto;
        max-height: 200px;
        max-width: 200px;
        img {
          height: auto;
          width: auto;
          max-height: 100%;
          max-width: 100%;
        }
      }
      .text-right {
        text-align: center !important;
      }
      .btns-div {
        justify-content: center;
      }
    }
  }
  ${LeftBanner} {
    transform: translate(0px, 0px);
    width: 100%;
    height: 35px;
    border-radius: 8px 8px 0px 0px;
    label {
      transform: translate(-50%, -50%) rotate(360deg);
      top: 50%;
      left: 50%;
    }
  }
  .option-carousel-wrapper {
    height: 150px !important;
    .carousel-inner {
      min-height: 50px;
      height: 150px !important;
    }
  }
  .purchase-middle-panel {
    height: 100vh;
    overflow-y: unset;
  }
  .purchase-data {
    > div > ${FlexContainer} > ${CustomLabel} {
      &:first-child {
        width: 200px;
        text-align: center !important;
      }
    }
  }
`;
export const CheckoutIframeWrapper = styled.div<IStyledProps>`
  width: ${(props) => props.width || "50%"};
  background: #f8f8f8;
  border-radius: 0px 0px 0px 10px;
  height: 100%;
  min-height: 400px;
  overflow-y: auto;
  padding: 40px 30px 40px 40px;

  /* New CSS */
  &.float-block {
    position: fixed;
    /* top: 55px;
    right: 20px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
    z-index: 1000;
    position: fixed; */
    top: 60px;
    right: 20px;
    box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.2);
    z-index: 1000;
    height: calc(100% - 72px);
    border-radius: 8px;
    display: flex;
  }
  justify-content: center;

  ${PurchaseColoredBackground} {
    height: unset !important;
    .purchase-section {
      height: unset !important;
    }
  }

  ${PurchaseWrapper} {
    height: unset;
    display: unset;
    flex-direction: unset;
  }

  @media (min-width: 1600px) and (max-width: 1900px) {
    &:not(.iframe-detail-page) {
      width: 50%;
    }
  }
  @media (min-width: 1901px) and (max-width: 2400px) {
    &:not(.iframe-detail-page) {
      width: 60%; // managing the width of the checkout left panel
    }
    .wrapped-columns {
      max-width: 1300px;
      flex-wrap: unset !important;
      flex-direction: row;
      justify-content: center;
      gap: 20px !important;
      background: red;
      > div {
        width: 100%;
      }
    }
  }
  @media (min-width: 2401px) {
    &:not(.iframe-detail-page) {
      width: 60%;
    }
  }
  @media (min-width: 769px) and (max-width: 1024px) {
    &.iframe-detail-page {
      .wrapped-columns {
        flex-wrap: inherit;
        &.wrapped-max-width {
          max-width: 100%;
          margin: 0 auto;
        }
        .item-right-panel {
          align-items: flex-start;
        }
        .item-header + label {
          text-align: inherit;
        }
        .option-qty {
          justify-content: flex-start;
        }
      }
    }
  }
`;
export const CheckoutPaymentWrapper = styled.div`
  .pay-field-chkbx {
    display: flex;
    align-items: center;
    width: 100%;
    ${CustomLabel} {
      font-weight: 600;
      margin: 20px 0px;
      &.pay-field-margin {
        margin-top: 0px;
        margin-bottom: 15px;
      }
    }
    .pay-inputs {
      flex: 1 1 0;
    }
    .drag-drop-icon {
      margin-right: 10px;
      cursor: pointer;
      i {
        color: #aaa;
        font-size: 21px;
        margin-top: 4px;
      }
    }
    .form-field-input-wrapper {
      max-width: 600px;
      input {
        width: 500px;
      }
    }
    .input-hint-icons {
      width: 30px;
      img {
        height: 20px;
        width: 20px;
        margin-left: 10px;
        margin-bottom: 4px;
      }
    }
    .input-addon-wrapper {
      width: 100%;
      .input-addon-icon {
        position: relative;
        width: 100%;
      }
      img {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translate(-11px, -9px);
      }
    }
    .username-input {
      .t-img {
        transform: translate(-13px, -11px);
      }
    }
    .req-chkbx {
      width: 113px;
      text-align: center;
    }
    .input-wrapper,
    .input-wrapper input,
    .single-select-wrapper,
    .single-select-wrapper .header {
      width: 100%;
    }
  }
  .chkout-pay-select {
    width: 500px;
    margin-left: 32px;
    /* margin-bottom: 10px; */
  }
  .chkout-pay__control {
    min-height: 70px;
    align-items: flex-start;
  }
  .moneyback-chkout {
    margin-left: 32px;
  }
  .marketing-soft-text {
    display: block;
    color: #979797;
    font-size: 12px;
    margin-top: 5px;
    margin-bottom: 25px;
  }
  .chkout-label-description {
    margin-bottom: 0px;
  }
  .seller-terms-dropdown {
    width: 220px;
    .header {
      width: 220px;
    }
    .select-header-span {
      color: #555;
    }
    .options-menu {
      min-width: 220px;
      width: auto;
    }
  }
  .seller-labels {
    width: 200px;
  }
  .seller-light-comments {
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    color: #aaa;
  }
  .surcharge-section {
    .styled-input.merchant-inputs {
      width: 450px;
      height: 64px;
      padding-left: 12px;
      margin-top: 10px;
    }
  }
  .seller-with-margin {
    margin-bottom: 5px;
  }
`;

export const AfterPayWrapper = styled.div<IStyledProps>`
  /* ${IconButton} {
        min-width: 125px;
        width: 125px;
        text-align: center;
        height: 50px;
        border-radius: 10px;
        color: #555;
        border: 1px solid #aaa;
        background-color: #f8f8f8;
        img {
            height: 18px;
            width: 18px;
        }
        &.active {
            border: 1px solid #57ac2d;
            background-color: #f7fff3;
        }
    } */
  ${LabelCell} {
    display: none;
    ${CustomLabel} {
      display: none;
    }
  }

  .afterpay-text-input {
    width: 250px;
    height: 40px;
  }
  .after-pay-web-url {
    width: 490px;
    min-height: 100px;
    border: 1px solid #aaa;
    border-radius: 4px;
    padding: 6px 7px;
    display: block;
    &:focus,
    &:hover {
      outline: none;
    }
  }
`;
export const CheckoutDetailPreviewSection = styled.div`
  width: 100%;
  ${MultiplePriceWrapper} {
    .bundle-flex {
      gap: 20px !important;
    }
    &.multiple-item-with-tab {
      ${MainOuterCard} {
        min-height: 200px;
        &.featured-banner {
          margin-top: 42px;
        }
      }
    }
    &.payment-price-wrapper {
      .divided-component.wrapped-columns {
        > div {
          max-width: 500px;
          width: 100% !important;
        }
      }
    }
  }
  ${PurchaseColoredBackground} {
    border-radius: 0px;
    padding: 30px 25px;
    // background-color: #f8f8f8;
    // border: none;
    .wrapped-columns {
      flex-wrap: wrap;
      justify-content: center;
      gap: 20px !important;
      > div {
        width: 100%;
      }
    }
    .recommended-outer-card {
      width: auto !important;
      max-width: 600px;
    }
    .item-header {
      font-size: 24px;
      line-height: 30px;
      text-align: center;
      & + label {
        text-align: center;
      }
    }
    .left-outer-card {
      /* width: 80% !important; */
      max-width: 600px !important;
      justify-content: center;
      align-items: center;
      .item-header {
        & + label {
          text-align: center;
          max-width: 37ch;
        }
      }
    }
    .item-right-panel {
      padding: 0px;
      align-items: center;
      .recommended-outer-card {
        width: 100% !important;
        max-width: 600px;
        padding: 55px 15px 24px 15px !important;
        min-height: 160px;
        &.no-recommendations {
          padding: 24px 15px !important;
        }
        .item-header {
          font-size: 22px;
          line-height: 26px;
          text-align: left;
          & + label {
            text-align: left;
            font-size: 12px;
            line-height: 16px;
            width: 100%;
          }
        }
      }
    }
    .multiple-item-with-tab {
      ${MainOuterCard} {
        width: inherit;
        max-width: 280px;
        min-height: 200px;
        padding: 20px 25px !important;
      }
    }
    .desc-width {
      width: inherit;
    }
    ${CustomButton} {
      min-width: 80px;
    }
    .purchase-section {
      padding: 25px 15px !important;
    }
  }
  ${PurchaseWrapper} {
    border: 1px solid #ccc;
    border-radius: 8px; // doubtfull
    height: 100vh;
    .purchase-profile {
      img {
        height: 30px;
        width: 30px;
      }
      ${FlexContainer} {
        gap: 5px;
      }
    }
    .purchase-steps {
      display: none;
    }
    .purchase-steps-subtopbar {
      display: block;
      /* margin-bottom: 10px; */
      > ${FlexContainer} {
        justify-content: center;
        margin-top: 10px;
        .fa-chevron-right {
          margin-right: 10px;
        }
      }
      &.topbar-with-margin {
        margin-top: 10px;
      }
    }
    ${PurchaseColoredBackground} {
      padding: 30px 20px;
    }
    .purchase-section {
      padding: 50px 15px;
    }
    .purchase-options-screen {
      .wrapped-columns {
        width: 400px;
        margin: 0 auto;
      }
      .option-carousel-wrapper {
        width: 100%;
        .carousel.slide {
          width: 100%;
        }
      }
      .options-right-panel {
        padding: 0px;
        label {
          text-align: left;
        }
      }
    }
    .item-header + label {
      text-align: left;
    }
    .addon-body-scroll {
      overflow-x: hidden;
      ${ItemDetailsCard} {
        width: 400px;
      }
      > ${FlexContainer} {
        padding: 10px 20px 0px !important;
      }
    }
    ${CheckoutItemsWrapper} {
      ${MainOuterCard} {
        padding: 30px 15px;
      }
    }

    .wrapped-columns {
      &.wrapped-max-width {
        max-width: 500px;
        margin: 0 auto;
      }
    }

    .purchase-nav-flex {
      padding: 0px;
    }
  }
  ${ItemDetailsCard} {
    > ${FlexContainer} {
      flex-direction: column-reverse;
      flex-wrap: wrap;
      align-items: center;
      ${CustomWidth} {
        &:first-child {
          width: 100%;
        }
        &:last-child {
          width: 100%;
        }
      }
      .add-on-image {
        margin: 0 auto;
        max-height: 200px;
        max-width: 200px;
        img {
          height: auto;
          width: auto;
          max-height: 100%;
          max-width: 100%;
        }
      }
      .text-right {
        text-align: center !important;
      }
      .btns-div {
        justify-content: center;
      }
    }
  }
  ${LeftBanner} {
    transform: translate(0px, 0px);
    width: 100%;
    height: 35px;
    border-radius: 8px 8px 0px 0px;
    label {
      transform: translate(-50%, -50%) rotate(360deg);
      top: 50%;
      left: 50%;
    }
  }
  .purchase-middle-panel {
    /* max-height: calc(100% - 370px); */
    height: auto;
    > div {
      height: 100%;
    }
    .purchase-section {
      height: 100%;
      > div {
        height: auto;
      }
    }
  }
`;

interface DropdownContainerProps extends HTMLAttributes<HTMLDivElement> {
  error?: string;
}

export const CountryFlag = styled.img`
  width: 24px;
  height: 24px;
  margin-right: 8px;
  cursor: pointer;
`;

export const DropdownWrapper = styled.div<DropdownContainerProps>`
  display: flex;
  align-items: center;
  padding: 5px;
  border-radius: 4px;
  border: ${(props) =>
    props.error === "true" ? "1px solid red" : "1px solid #ccc"};
  width: 400px;
  .input-wrapper input {
    color: #555;
    &::placeholder {
      color: #aaa;
    }
  }
  .btn-outline-secondary {
  }
`;

export const OptionsDropdownContainer = styled.div`
  margin: 0px;
  /* margin-right: 20px; */
  display: flex;
  flex-direction: column;
  &.ps-country-dpdn {
    .dropdown-menu {
      max-height: 115px;
      overflow-y: auto;
      max-width: unset;
      width: auto !important;
      transform: translate(-7px, 38px) !important;

      &::-webkit-scrollbar {
        width: 0.7em;
        height: 0.4em;
        background-color: #15283717;
        border-radius: 10px;
      }
      &::-webkit-scrollbar-thumb {
        outline: 1px solid #ddd;
        background-color: rgba(21, 40, 55, 0.3);
        border-radius: 10px;
      }
      .dropdown-search-input {
        border-bottom: 1px solid #ccc !important;
      }
    }
    .phone-data{
      font-size: 16px !important;
    }
  }
  &.tax-country-dropdown.country-dpdn {
    max-width: 185px;
    > div {
      max-width: 185px;
    }
    .custom-label {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
`;
export const StyledDropdownButton = styled(DropdownButton)`
  display: flex;
  align-items: center;
  border: none;
  background: none;
  cursor: pointer;

  & > .dropdown-toggle::after {
    margin-left: 0.25em;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(10px, 10px);
    margin-right: 5px;
    color: #aaa;
    &:hover {
      color: #aaa;
    }
  }
  .styled-dropdown-flex {
    padding: 0px;
    height: 20px;
  }
  button {
    min-width: 60px;
    height: 22px;
    padding: 0px;
    border-radius: 4px;
    border: none;
    background: #fff;
    cursor: pointer;
    &:focus,
    &:focus-visible,
    &:hover,
    &:active,
    &.show {
      border-color: transparent;
      background: #fff;
      box-shadow: none !important;
      ::after {
        color: #555;
        &:hover {
          color: #555;
        }
      }
    }
    &:first-child:active {
      border-color: transparent;
      background: #fff;
    }
  }
  .dropdown-menu {
    transform: translate3d(-3px, 24.6364px, 0px);
    a.dropdown-item {
      padding: 0px 7px;
      &:active {
        color: #555;
        background: #f8f9f9;
        outline: none;
      }
    }
  }
  label {
    cursor: pointer;
  }
`;

export const StyledInput = styled(Input)`
  border: none;
  padding-left: 10px;
  flex-grow: 1;
  outline: none;
`;
